<template>
  <b-modal ref="additional-requests-modal-ref" hide-footer title="Additional Requests">
    <!-- Using Baggage data because Projects ask to follow the same logic -->
    <div v-if="baggage">
      <p>
        Below you will find details of any additional requests made with the airline on your behalf.
        Where indicated, this also includes membership numbers we have added to your booking.
      </p>
      <p class="mb-md-0">
        Names will only appear when additional requests have been made and in some cases with
        certain airlines on some routes, additional requests are not possible so will not therefore
        display any.
      </p>
      <div v-if="flightsArr.length > 0" class="d-flex expand-collapse-container">
        <button class="vtd-btn mt-3" @click="toggleExpandAll">
          {{ buttonText }}
        </button>
      </div>

      <div v-if="flightsArr.length === 0">
        <p class="mt-3">No flights found for your booking</p>
      </div>
      <div v-for="(flight, index) in flightsArr" :key="index">
        <Passengers
          :id="flight.flightno"
          :flight="flight"
          :flight-no="flight.flightno"
          :itinerary="matchingItinerary(flight.flightno, flight.galLocator, flight.deptime)"
          :dropdown-prop="checkDates(index)"
          :expand-all-prop="expandAll" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Passengers from './passengers.vue'

export default {
  components: {
    Passengers,
  },
  props: {
    itineraryArr: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      flightNo: '',
      expandAll: false,
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$refs.itineraryItemRef && this.$refs.itineraryItemRef[0]) {
        this.$refs.itineraryItemRef[0].toggleExpand()
      }
    })
    this.$refs['additional-requests-modal-ref'].$on('hide', this.onHide)
  },
  computed: {
    ...mapGetters({
      accountInfo: 'booking/getAccount',
      baggage: 'baggage/getBaggage',
      bookingInfo: 'booking/getBookingInfo',
      bookingNumber: 'booking/getBookingNumber',
      destination: 'booking/getDestination',
      friendFamily: 'friendFamily/isFriendFamily',
      itinerary: 'booking/getItinerary',
      userData: 'auth/getUserData',
    }),
    buttonText() {
      return this.expandAll ? 'Close All' : 'Expand All'
    },
    flightsArr() {
      let arr = []
      let dupeHandBaggObj = {}
      this.baggage.checked.forEach((item) => {
        let { galLocator } = item
        item.flights.forEach((flight) => {
          const matchingItinItem = this.matchingItinerary(
            flight.flightno,
            galLocator,
            flight.deptime
          )
          flight.depdate = matchingItinItem.depdate
          if (
            !dupeHandBaggObj[`${flight.flightno}`] ||
            (dupeHandBaggObj[`${flight.flightno}`] &&
              (dupeHandBaggObj[`${flight.flightno}`].deptime !== flight.deptime ||
                dupeHandBaggObj[`${flight.flightno}`].vendorloc !== matchingItinItem.vendorloc))
          ) {
            dupeHandBaggObj[`${flight.flightno}`] = { deptime: '', vendorloc: '' }
            dupeHandBaggObj[`${flight.flightno}`].deptime = flight.deptime
            dupeHandBaggObj[`${flight.flightno}`].vendorloc = matchingItinItem.vendorloc
            arr.push(flight)
          }
        })
      })
      // sort the resulting array by depdate
      arr.sort((a, b) => {
        const dateA = new Date(a.depdate)
        const dateB = new Date(b.depdate)
        // if two dates are the same, compare flights by deptime
        if (dateA.getTime() === dateB.getTime()) {
          const timeA = new Date(a.deptime)
          const timeB = new Date(b.deptime)
          return timeA.getTime() - timeB.getTime()
        } else {
          // otherwise, compare by date
          return dateA.getTime() - dateB.getTime()
        }
      })
      return arr
    },
  },
  methods: {
    showModal(flightNo) {
      if (flightNo) this.flightNo = flightNo
      this.$refs['additional-requests-modal-ref'].show()
      if (flightNo) {
        setTimeout(() => {
          document.getElementById(flightNo).scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 1200)
      }
    },
    onHide() {
      setTimeout(() => {
        this.expandAll = false
      }, 400)
    },
    matchingItinerary(flightNo, galLocator, departureTime) {
      const matchingItems = this.itineraryArr.filter((item) => {
        const _values = Object.values(item)
        return _values.includes(galLocator) && _values.includes(flightNo)
      })
      if (matchingItems.length === 1) {
        return matchingItems[0]
      } else if (!matchingItems.length) {
        return {}
      }
      // else, more than 1 flight with the same flight number and gal locator (e.g. BA2159 LGW-UVF-GND. The flight touches down in St Lucia (UVF) and then continues to Grenada. Same flight number.)
      // so, match by departure time as well
      const correctFlight = matchingItems.find((item) => {
        let _formattedDepTime = item.deptime.replace(':', '').trim()
        return _formattedDepTime === departureTime.trim()
      })
      return correctFlight ? correctFlight : matchingItems[0]
    },
    checkDates(index) {
      const today = new Date().getTime()
      const depDates = this.itineraryArr.map((item) => {
        return Date.parse(item.depdate)
      })
      // if holiday has not yet begun, open first dropdown
      if (today < depDates[0] && index === 0) {
        return true
      } else if (today >= depDates[0]) {
        // if holiday has begun, open dropdowns programatically
        let count = 0
        for (let i = 0; i < depDates.length; i++) {
          if (today > depDates[i]) {
            count++
          }
        }
        if (count === index) {
          return true
        }
      } else {
        return false
      }
    },
    toggleExpandAll() {
      this.expandAll = !this.expandAll
    },
  },
}
</script>

<style>
@import './styles.scss';
</style>
